/**
 * @generated SignedSource<<f8ef6cafcc61117c4164e6336ef88b4e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RegistrationSendVerificationEmailInput = {
  checkoutId: string;
};
export type useRegistrationSendVerificationEmailMutation$variables = {
  input: RegistrationSendVerificationEmailInput;
};
export type useRegistrationSendVerificationEmailMutation$data = {
  readonly registrationSendVerificationEmail: {
    readonly data: boolean | null;
    readonly errors: ReadonlyArray<{
      readonly field: string;
      readonly message: string;
    }> | null;
  };
};
export type useRegistrationSendVerificationEmailMutation = {
  response: useRegistrationSendVerificationEmailMutation$data;
  variables: useRegistrationSendVerificationEmailMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RegistrationSendVerificationResponse",
    "kind": "LinkedField",
    "name": "registrationSendVerificationEmail",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "data",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ValidationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "field",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useRegistrationSendVerificationEmailMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useRegistrationSendVerificationEmailMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "204c35cff435bc4c54d1d1f6d3e34e77",
    "id": null,
    "metadata": {},
    "name": "useRegistrationSendVerificationEmailMutation",
    "operationKind": "mutation",
    "text": "mutation useRegistrationSendVerificationEmailMutation(\n  $input: RegistrationSendVerificationEmailInput!\n) {\n  registrationSendVerificationEmail(input: $input) {\n    data\n    errors {\n      field\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "31290f34b258bfe54b8e4f9c87bc5fdd";

export default node;
